module.exports = __webpack_public_path__ + "static/media/22ESCWA21.51ccfcd6.jpg";